import React, { FC } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { Typography } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { DedicatedLanesResponse } from 'apps/marketplace/apiTypes/dedicatedLanes'
import { DISPLAY } from 'constants/display'

interface IDedicatedLaneAdditionalNotesProps {
  dedicatedLane?: DedicatedLanesResponse
}

export const DedicatedLaneAdditionalNotes: FC<IDedicatedLaneAdditionalNotesProps> = ({
  dedicatedLane,
}) => {
  const { listingDetails } = dedicatedLane ?? {}
  const { note } = listingDetails ?? {}
  const { isMobile } = useBreakpointContext()

  return (
    <Card dataTest='dedicated-lane-additional-notes-card'>
      <Typography variant='subtitle1' className={isMobile ? 'mb3' : ''}>
        Additional Notes
      </Typography>

      <Typography
        data-test='dedicated-lane-additional-notes-body'
        className={isMobile ? 'mt1 mb2' : 'mt1'}
        variant='body1'>
        {note ?? DISPLAY.empty}
      </Typography>
    </Card>
  )
}
